export default __webpack_public_path__ + "static/media/campaigns_selected.70c9b39e.svg";